"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VGS_SCRIPT_URL = exports.VGSConfig = void 0;
exports.VGSConfig = {
    VAULT_ID_DEV: 'tnt4qi5g1nk',
    VAULT_ID_PROD: 'tntermlxyzg',
    ENVIRONMENT_DEV: 'sandbox',
    ENVIRONMENT_PROD: 'live'
};
exports.VGS_SCRIPT_URL = 'https://js.verygoodvault.com/vgs-collect/2.7.0/vgs-collect.js';
